import ModalApiConfirmationImage from './ModalApiConfirmationImage';

export default ModalApiConfirmationImage;
